import { render, staticRenderFns } from "./SectionCard.vue?vue&type=template&id=72ef7b0f&"
import script from "./SectionCard.vue?vue&type=script&lang=js&"
export * from "./SectionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72ef7b0f')) {
      api.createRecord('72ef7b0f', component.options)
    } else {
      api.reload('72ef7b0f', component.options)
    }
    module.hot.accept("./SectionCard.vue?vue&type=template&id=72ef7b0f&", function () {
      api.rerender('72ef7b0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/SectionCard.vue"
export default component.exports